import request from './fetcher/request'
import client from '@/client/modules/common'

/**
 * 获取客户端扩展信息（统一处理设备信息与异常）
 */
async function getClientExt() {
  try {
    const { lastver } = await client.API.client_get_device_info()
    return { lastver: lastver ? String(lastver) : '0' }
  } catch (error) {
    return { lastver: '0' }
  }
}

// 获取支付信息第三版
function getPaySetting (data) {
  return request.post('/api/sdk/service/settings', data)
}
// 获取二维码信息
async function getPayQrcode (data) {
  const requestData = {
    ...data,
    client_ext: await getClientExt()
  }
  return request.post('/api/sdk/service/pay', requestData)
}
// 支付结果轮询接口
function getPayResult (data) {
  return request.post('/api/sdk/service/order_result', data)
}

/**
 * 支付中间页查看用户是否已经购买订单
 */
function getH5PayResult (data) {
  return request.post('/api/sdk/service/pay_status', data)
}

/**
 * 中间页扫码调起服务端上报
 * @param {object} data
 * @returns
 */
function scanQrReportByService (data) {
  return request.post('/api/sdk/service/pay/report', data)
}

/**
 * 微信支付中间页上报参数缓存
 */
function cacheH5PageReportParams (data) {
  return request.post('/api/sdk/service/gen_pay_certificate', data)
}

/**
 * 中间页获取上报参数&判断是否能下单
 */
function getH5ReportParamAndcheckCanCreateOrder (data) {
  return request.post('/api/sdk/service/pay_certificate', data)
}

/**
 * 米大师 - 道具直购创建订单接口
 */
async function createMidasOrderByTool (data) {
  const requestData = {
    ...data,
    client_ext: await getClientExt()
  }
  return request.post('/api/sdk/midaspay/goods_pay', requestData)
}

/**
 * 米大师 - H5联调（标准包月）创建订单接口
 */
async function createMidasOrderByStandardPackage (data) {
  const requestData = {
    ...data,
    client_ext: await getClientExt()
  }
  return request.post('/api/sdk/midaspay/month_pay', requestData)
}

export {
  getPayResult, getPayQrcode, getPaySetting, getH5PayResult,
  scanQrReportByService, cacheH5PageReportParams,
  getH5ReportParamAndcheckCanCreateOrder, createMidasOrderByTool,
  createMidasOrderByStandardPackage
}
